import {createAction, props} from '@ngrx/store';

export const loadCalculators = createAction(
  '[Calculator] Load Calculators',
);
export const createNewOrderSuccess = createAction(
  '[Calculator] Create New Order Success'
);

export const createNewOrderFailed = createAction(
  '[Calculator] Create New Order Failed',
  props<{ error: string }>()
);
export const InitNewCalc = createAction(
  '[Calculator] InitNewCalc'
);
export const initUpdateOrder = createAction(
  '[Calculator] Init Update Order',
  props<{ orderID: number }>()
);
